import type React from "react";
import type { MemberAttribute } from "../../../shared/types/member.types";
import { MemberAttributeFilters } from "../components/MemberAttributeFilters";
import { FILTER_PRESETS } from "../config/filterPresets";

interface AudienceSelectionFiltersProps {
	memberAttributes: MemberAttribute[];
}

export const MemberAttributeAudienceFilters: React.FC<
	AudienceSelectionFiltersProps
> = ({ memberAttributes }) => (
	<MemberAttributeFilters
		memberAttributes={memberAttributes}
		config={FILTER_PRESETS.audienceSelection}
	/>
);
